import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Mail, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { IconInput, PasswordInput } from "@/pages/Login";
import { PORTALS } from "@/pages/admin/AdminLayout";

export default function AdminLogin({ mode = "admin" }) {
  const { user, setUser, logout } = useAuth();
  const nav = useNavigate();
  const p = PORTALS[mode];
  const [f, setF] = useState({ identifier: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  if (user && user.role === p.role) return <Navigate to={p.base} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (!f.identifier || !f.password) return setErr("Enter your admin email and password");
    setBusy(true);
    try {
      if (user) await logout();
      const { data } = await api.post("/auth/login", { ...f, remember: false, portal: mode });
      setUser(data);
      toast.success(`Signed in to ${p.label} panel`);
      nav(p.base, { replace: true });
    } catch (e2) {
      setErr(apiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid={`${mode}-login-page`} className="grid min-h-screen place-items-center bg-cr-bg px-5">
      <form onSubmit={submit} noValidate data-testid="admin-login-form" className="card-gold w-full max-w-md p-8">
        <img src="/brand/logo.png" alt="CRBETS" className="mx-auto h-20 mix-blend-lighten" />
        <div className="mt-4 flex items-center justify-center gap-2"><ShieldCheck className="h-5 w-5 text-cr-gold" /><h1 className="text-2xl font-bold">{p.label} Portal</h1></div>
        <p className="mt-1 text-center text-sm text-cr-muted">Authorised staff only</p>
        <label className="mt-8 block text-sm font-semibold">Admin email</label>
        <div className="mt-2"><IconInput icon={Mail} data-testid="admin-login-email" autoComplete="username" placeholder="admin email" value={f.identifier} onChange={(e) => setF({ ...f, identifier: e.target.value })} /></div>
        <label className="mt-5 block text-sm font-semibold">Password</label>
        <div className="mt-2"><PasswordInput testid="admin-login-password" autoComplete="current-password" placeholder="Password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} /></div>
        {err && <p data-testid="admin-login-error" role="alert" className="mt-4 rounded-md border border-cr-danger/40 bg-cr-danger/10 px-3 py-2 text-sm text-cr-danger">{err}</p>}
        <button disabled={busy} data-testid="admin-login-submit" className="btn-gold mt-6 w-full py-3.5">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </main>
  );
}
